import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { CustomSnackbarComponent } from '../../components/molecules/custom-snackbar/custom-snackbar.component';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  constructor(private snackBar: MatSnackBar) {}

  private persistentAction?: symbol;

  holdAction(): { open: (message: string, action: string) => ReturnType<MatSnackBar['open']>; release: () => void } {
    const owner = Symbol();
    this.persistentAction = owner;
    let notice: ReturnType<MatSnackBar['open']> | undefined;
    return {
      open: (message, action) => notice = this.snackBar.open(message, action, { duration: 0 }),
      release: () => {
        if (this.persistentAction === owner) this.persistentAction = undefined;
        notice?.dismiss();
      },
    };
  }

  show(message: string, duration: number = 3000) {
    if (this.persistentAction) return;
    const config: MatSnackBarConfig = {
      duration: duration,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: ['custom-snackbar'],
    };

    this.snackBar.openFromComponent(CustomSnackbarComponent, {
      data: message,
      ...config,
    });
  }
}
